module.exports = "/*Pagination CSS */\r\n.page-link {\r\n    cursor: pointer;\r\n}\r\n.page-link:hover {\r\n    color: black;\r\n    background-color: white;\r\n}\r\n.custom-width{\r\n    width:80px ;\r\n}\r\nul {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    overflow: hidden;\r\n}\r\nli {\r\n    float: left;\r\n}\r\n.pagination-margin{\r\n    margin-top: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-controls/pagination-v2/pagination.component.css
// module id = ./src/app/user-controls/pagination-v2/pagination.component.css
// module chunks = main